import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
    RenderKilogramo,
    RenderNumberPercentage,
} from "../../../../../../../Utils/renderField/renderReadField";
import NullableValue from "../../../../../../../Utils/renderField/nullableValue";
import { formatIdBultoSkim } from "../../../../../helpers/formatValues";
const eliminarIcon = require("assets/img/icons/borrar.png");
const editarIcon = require("assets/img/icons/editar.png");
const rightArrowIcon = require("assets/img/icons/right-arrow.png");

export const TancadasTable = ({ tancadas, EliminarTancada, modoLectura }) => {
    const [openRows, setOpenRows] = useState([]);

    const toggleRow = (id) => {
        setOpenRows((prev) =>
            prev.includes(id)
                ? prev.filter((rowId) => rowId !== id)
                : [...prev, id],
        );
    };

    return (
        <div className="new-table-wrapper tancadas__table-wrapper mx-auto mb-4">
            <table>
                <thead>
                    <tr>
                        <th style={{ minWidth: "210px" }}>Almacén</th>
                        <th>Materia prima</th>
                        <th>Kg húmedos</th>
                        <th>DRC</th>
                        <th>Kg secos</th>
                    </tr>
                </thead>
                <tbody>
                    {tancadas.length === 0 && (
                        <tr>
                            <td colSpan={5} className="text-center">
                                No hay tancadas registradas
                            </td>
                        </tr>
                    )}

                    {tancadas.map((item) => (
                        <React.Fragment key={item.id}>
                            {/* FILA PRINCIPAL */}
                            <tr
                                className={`tancadas__expansible-row ${openRows.includes(item.id) ? "expanded" : ""}`}
                                onClick={() => toggleRow(item.id)}
                            >
                                <td colSpan={5}>
                                    <div className="table-actions justify-content-start align-items-center">
                                        {!modoLectura && (
                                            <div
                                                className="table-actions"
                                                style={{ minWidth: "61px" }}
                                            >
                                                <React.Fragment>
                                                    <Link
                                                        to={`/produccion-v2/cargas-tancada/${item.id}`}
                                                    >
                                                        <img
                                                            src={editarIcon}
                                                            alt="Editar"
                                                            className="action_img"
                                                        />
                                                    </Link>
                                                    <img
                                                        src={eliminarIcon}
                                                        alt="Eliminar"
                                                        className="action_img"
                                                        onClick={() =>
                                                            EliminarTancada(
                                                                item.id,
                                                            )
                                                        }
                                                    />
                                                </React.Fragment>
                                            </div>
                                        )}

                                        <span className="ml-2">
                                            Tancada{" "}
                                            {item.numero}
                                        </span>

                                        <img
                                            src={rightArrowIcon}
                                            alt="Expandir"
                                            className={`ml-auto action_img expand-icon`}
                                            style={{
                                                width: "16px",
                                                height: "16px",
                                            }}
                                        />
                                    </div>
                                </td>
                            </tr>

                            {/* FILA EXPANDIDA */}
                            {openRows.includes(item.id) &&
                                (item.cargas_tancada.length === 0 ? (
                                    <tr>
                                        <td colSpan={5}>No hay cargas</td>
                                    </tr>
                                ) : (
                                    <React.Fragment>
                                        {item.cargas_tancada.map((carga) => (
                                            <tr key={carga.id}>
                                                <td className="text-center text-nowrap">
                                                    {carga.almacen.nombre}
                                                    {carga.bulto_skim &&
                                                        " - " +
                                                            formatIdBultoSkim(
                                                                carga.bulto_skim,
                                                            )}
                                                </td>
                                                <td className="text-center">
                                                    {
                                                        carga.almacen
                                                            .materia_prima
                                                            .nombre
                                                    }
                                                </td>
                                                <td className="text-center text-nowrap">
                                                    <RenderKilogramo
                                                        value={carga.kg_humedos}
                                                        decimals={3}
                                                    />
                                                </td>
                                                <td className="text-center text-nowrap">
                                                    <NullableValue
                                                        value={carga.drc}
                                                    >
                                                        <RenderNumberPercentage
                                                            value={carga.drc}
                                                            decimals={2}
                                                        />
                                                    </NullableValue>
                                                </td>
                                                <td className="text-center text-nowrap">
                                                    <NullableValue
                                                        value={carga.kg_secos}
                                                    >
                                                        <RenderKilogramo
                                                            value={
                                                                carga.kg_secos
                                                            }
                                                            decimals={3}
                                                        />
                                                    </NullableValue>
                                                </td>
                                            </tr>
                                        ))}
                                        <tr
                                            key={`totals-${item.id}`}
                                            className="totales-row"
                                        >
                                            <td
                                                colSpan={2}
                                                className="text-right"
                                            >
                                                <strong>Totales:</strong>
                                            </td>
                                            <td className="text-center">
                                                <RenderKilogramo
                                                    value={item.cargas_tancada.reduce(
                                                        (sum, carga) =>
                                                            sum +
                                                            parseFloat(
                                                                carga.kg_humedos,
                                                            ),
                                                        0,
                                                    )}
                                                    decimals={3}
                                                />
                                            </td>
                                            <td></td>
                                            <td className="text-center">
                                                <RenderKilogramo
                                                    value={item.cargas_tancada.reduce(
                                                        (sum, carga) =>
                                                            sum +
                                                            parseFloat(
                                                                carga.kg_secos ||
                                                                    0,
                                                            ),
                                                        0,
                                                    )}
                                                    decimals={3}
                                                />
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
